/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CoreTimesheetScopeResponseDto } from '../models/core-timesheet-scope-response-dto';
import { timesheetScopesControllerCreate } from '../fn/timesheet-scopes/timesheet-scopes-controller-create';
import { TimesheetScopesControllerCreate$Params } from '../fn/timesheet-scopes/timesheet-scopes-controller-create';
import { timesheetScopesControllerDelete } from '../fn/timesheet-scopes/timesheet-scopes-controller-delete';
import { TimesheetScopesControllerDelete$Params } from '../fn/timesheet-scopes/timesheet-scopes-controller-delete';
import { timesheetScopesControllerFindAll } from '../fn/timesheet-scopes/timesheet-scopes-controller-find-all';
import { TimesheetScopesControllerFindAll$Params } from '../fn/timesheet-scopes/timesheet-scopes-controller-find-all';
import { timesheetScopesControllerFindOne } from '../fn/timesheet-scopes/timesheet-scopes-controller-find-one';
import { TimesheetScopesControllerFindOne$Params } from '../fn/timesheet-scopes/timesheet-scopes-controller-find-one';
import { timesheetScopesControllerUpdate } from '../fn/timesheet-scopes/timesheet-scopes-controller-update';
import { TimesheetScopesControllerUpdate$Params } from '../fn/timesheet-scopes/timesheet-scopes-controller-update';

@Injectable({ providedIn: 'root' })
export class CoreTimesheetScopesService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timesheetScopesControllerFindAll()` */
  static readonly TimesheetScopesControllerFindAllPath = '/o2-core/timesheet-scopes/{tenant}';

  /**
   * Get all timesheet scopes for a tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetScopesControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerFindAll$Response(params: TimesheetScopesControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreTimesheetScopeResponseDto>>> {
    const obs = timesheetScopesControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all timesheet scopes for a tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetScopesControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerFindAll(params: TimesheetScopesControllerFindAll$Params, context?: HttpContext): Observable<Array<CoreTimesheetScopeResponseDto>> {
    const resp = this.timesheetScopesControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<Array<CoreTimesheetScopeResponseDto>>): Array<CoreTimesheetScopeResponseDto> => r.body)
    );
  }

  /** Path part for operation `timesheetScopesControllerCreate()` */
  static readonly TimesheetScopesControllerCreatePath = '/o2-core/timesheet-scopes/{tenant}';

  /**
   * Create a new timesheet scope.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetScopesControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetScopesControllerCreate$Response(params: TimesheetScopesControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>> {
    const obs = timesheetScopesControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new timesheet scope.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetScopesControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetScopesControllerCreate(params: TimesheetScopesControllerCreate$Params, context?: HttpContext): Observable<CoreTimesheetScopeResponseDto> {
    const resp = this.timesheetScopesControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>): CoreTimesheetScopeResponseDto => r.body)
    );
  }

  /** Path part for operation `timesheetScopesControllerFindOne()` */
  static readonly TimesheetScopesControllerFindOnePath = '/o2-core/timesheet-scopes/{tenant}/{id}';

  /**
   * Get a timesheet scope by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetScopesControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerFindOne$Response(params: TimesheetScopesControllerFindOne$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>> {
    const obs = timesheetScopesControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a timesheet scope by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetScopesControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerFindOne(params: TimesheetScopesControllerFindOne$Params, context?: HttpContext): Observable<CoreTimesheetScopeResponseDto> {
    const resp = this.timesheetScopesControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>): CoreTimesheetScopeResponseDto => r.body)
    );
  }

  /** Path part for operation `timesheetScopesControllerDelete()` */
  static readonly TimesheetScopesControllerDeletePath = '/o2-core/timesheet-scopes/{tenant}/{id}';

  /**
   * Delete a timesheet scope.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetScopesControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerDelete$Response(params: TimesheetScopesControllerDelete$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
    const obs = timesheetScopesControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a timesheet scope.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetScopesControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timesheetScopesControllerDelete(params: TimesheetScopesControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.timesheetScopesControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `timesheetScopesControllerUpdate()` */
  static readonly TimesheetScopesControllerUpdatePath = '/o2-core/timesheet-scopes/{tenant}/{id}';

  /**
   * Update a timesheet scope.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timesheetScopesControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetScopesControllerUpdate$Response(params: TimesheetScopesControllerUpdate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>> {
    const obs = timesheetScopesControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a timesheet scope.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timesheetScopesControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timesheetScopesControllerUpdate(params: TimesheetScopesControllerUpdate$Params, context?: HttpContext): Observable<CoreTimesheetScopeResponseDto> {
    const resp = this.timesheetScopesControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreTimesheetScopeResponseDto>): CoreTimesheetScopeResponseDto => r.body)
    );
  }

}
